import { createRecipe } from './runtime.js';

const stackItemConfig = {"name":"stackItem","defaultVariants":{"size":"static"},"variantMap":{"alignSelf":["auto","baseline","center","flex-end","flex-start","stretch"],"size":["fill","static"]}}

export const stackItem = /* @__PURE__ */ createRecipe(stackItemConfig)